import React, { useEffect, useRef, useState } from "react";
import SearchInput from './search-input';
import store from "../store";
import { CopyIcon, DirectionIcon, EditIcon, TrashIcon2, exportIcon, importIcon, moreIcon, printIcon, refreshIcon } from "./icons-svg";
import InputDropdown from './input-dropdown';
import Tooltip from "./tooltip";
import InputCheckBox from "./input-checkbox";
import ConfirmationModal from "./confirmation-modal";
import InfoModal from "./info-modal";
import { DialogContentText, IconButton, Menu, MenuItem } from "@material-ui/core";
import CompileDialogForReview from "./compileDialogForReview";
import consts from "shared/consts";
import useFeature from "../utils/subscriptionWrapper";
import CustomModal from "./custom-modal";
import Progress from "./progress";
import InputText from "./input-text";

function qs() {
    return require('qs').parse(location.search.slice(1));
}

export default function DiscoverSimulationFilterTabs(props) {
    let REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS = useFeature(consts.FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS);

    const [reviewAbiFuncNames, setReviewAbiFuncNames] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [showRerunConfirmation, setShowRerunConfirmation] = useState(false);
    const [showRerunInfo, setShowRerunInfo] = useState(false);

    const [showCopyFromTemplateModal, setShowCopyFromTemplateModal] = useState(false);
    const [copyFromTemplateId, setCopyFromTemplateId] = useState('');
    const [copyFromTemplateIdHasError, setCopyFromTemplateIdHasError] = useState(false);
    const [copyFromTemplateIdErrorText, setCopyFromTemplateIdErrorText] = useState('');
    const [copyFromTemplateInProgress, setCopyFromTemplateInProgress] = useState(false);

    const [showCopySimulationModal, setShowCopySimulationModal] = useState(false);
    const [copyFromReviewId, setCopyFromReviewId] = useState('');
    const [copyFromReviewIdHasError, setCopyFromReviewIdHasError] = useState(false);
    const [copyFromReviewIdErrorText, setCopyFromReviewIdErrorText] = useState('');
    const [copySimulationInProgress, setCopySimulationInProgress] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMoreOptions = Boolean(anchorEl);
    const inputFile = useRef(null);

    useEffect(() => {
        clearSearch();
        if (qs().review_id) {
            getReviewAbuFunctionNames();
            store.fetchTemplateList();
        }
    }, [qs().review_id]);

    store.useRerenderIfChange(() => [store.getAllSimulationSelectionStatus(), Object.keys(store.selectedSimulationList).length, store.allSimulations, store.isTemplateReview])

    const clearSearch = () => {
        setSearchString('');
        store.updateSimulationFilter('searchText', '');
    }

    const getReviewAbuFunctionNames = async () => {
        let { abi } = await store.getReviewFilesAbiAndByteCode();
        abi = abi.filter(x => x.type == "function")
        let funcNames = abi.map(func => func.name);
        setReviewAbiFuncNames(funcNames);
    }

    const getAllSimulationFunctionList = () => {
        let simulationFuncs = getSimulationFunctions();
        let allFuncs = [];
        if (reviewAbiFuncNames && reviewAbiFuncNames.length) {
            allFuncs = [...new Set([...reviewAbiFuncNames, ...simulationFuncs])];
        } else {
            allFuncs = simulationFuncs;
        }
        allFuncs = allFuncs.map(funcName => {
            let numOfOccurances = getNumOfOccurances(funcName);
            return {
                label: funcName + ' (' + numOfOccurances + ')',
                value: funcName
            }
        })
        allFuncs = sortFuncsByName(allFuncs);
        if (!!allFuncs.length) {
            allFuncs.unshift({
                label: 'All',
                value: 'All'
            });
        }
        return allFuncs;
    }

    const getNumOfOccurances = (funcName) => {
        let funcs = {};
        store.allSimulations.forEach(simulation => {
            simulation.functionsInUse?.forEach(func => {
                funcs[func.name] = funcs[func.name] ? funcs[func.name] + func.numOfOccurances : func.numOfOccurances;
            });
        });
        return funcs[funcName] || 0;
    }

    const sortFuncsByName = (functionsInUse) => {
        if (!functionsInUse) return []
        functionsInUse?.sort((funcA, funcB) => {
            if (funcA.label.toLowerCase() < funcB.label.toLowerCase()) {
                return -1;
            }
            if (funcA.label.toLowerCase() > funcB.label.toLowerCase()) {
                return 1;
            }
            return 0;
        })
        return functionsInUse;
    }

    const getSimulationFunctions = () => {
        let allFuncsInUse = [];
        store.allSimulations?.forEach(simulation => {
            simulation.functionsInUse?.forEach(func => {
                allFuncsInUse = [...allFuncsInUse, func.name]
            })
        })
        return [...new Set(allFuncsInUse)];
    }

    const getAllSimulationCreatorList = () => {
        let creatorList = [{
            label: 'All',
            value: 'All'
        }];
        let creators = {};
        for (let i = 0; i < store.allSimulations.length; i++) {
            if (!creators[store.allSimulations[i]['userName']]) {
                creators[store.allSimulations[i]['userName']] = true;
            }
        }
        let creatorsList = Object.keys(creators);
        for (let i = 0; i < creatorsList.length; i++) {
            creatorList.push({
                label: creatorsList[i],
                value: creatorsList[i]
            })
        }
        return creatorList;
    }

    const getAllSimulationTemplateList = () => {
        let templateList = [{
            label: 'All',
            value: 'All'
        }];
        let templates = {};
        for (let i = 0; i < store.allSimulations.length; i++) {
            if (store.allSimulations[i]['template_id']
                && !templates[store.allSimulations[i]['template_id']]) {
                templates[store.allSimulations[i]['template_id']] = store.allSimulations[i]['template_data']['name'];
            }
        }
        let templatesList = Object.keys(templates);
        for (let i = 0; i < templatesList.length; i++) {
            templateList.push({
                label: templates[templatesList[i]],
                value: templatesList[i]
            })
        }
        return templateList;
    }

    const getAllSimulationPassFailList = () => {
        return [
            {
                label: 'All',
                value: 'All'
            },
            {
                label: 'Pass',
                value: 'Pass'
            },
            {
                label: 'Fail',
                value: 'Fail'
            }
        ]
    }

    const getSortByTypes = () => {
        return [
            {
                label: 'Name',
                value: 'Name'
            },
            {
                label: 'Created',
                value: 'Created'
            },
            {
                label: 'Modified',
                value: 'Modified'
            }
        ]
    }

    const getSimulationTypeList = () => {
        return [
            {
                label: 'All',
                value: 'All'
            },
            {
                label: 'Attached to task',
                value: 'Attached to task'
            },
            {
                label: 'Not attached to task',
                value: 'Not attached to task'
            }
        ]
    }

    const onChangeFile = (e) => {
        e.stopPropagation();
        e.preventDefault();
        store.importSimulationFromJSON(e);
    }

    const changeAllSimulationSelection = (value) => {
        if (value) {
            store.selectAllSimulations();
        } else {
            store.deSelectAllSimulations();
        }
    }

    const onRefresh = async () => {
        await store.invalidateReviewAbiCache(qs().review_id);
        store.fetchSimulationListMetadata(true);
    }

    const deleteSimulation = async () => {
        let selectedSimulationListArr = Object.keys(store.selectedSimulationList);
        for (let i = 0; i < selectedSimulationListArr.length; i++) {
            store.removeSimulationById(selectedSimulationListArr[i], props.isLoggedIn?.name);
        }
        setShowDeleteConfirmation(false);
    }



    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onDefineDefaultStepClick = async () => {
        await store.onDefineDefaultStepClick(REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS, store.selectedReviewData.defaultStepSimulationId, store.selectedReviewData._id, store.selectedReviewData.engagementData._id);
    }

    const getTemplateList = () => {
        let templateList = store.templates.map((review) => {
            return {
                label: review.name,
                value: review._id,
                disabled: false
            }
        });
        return templateList;
    }

    const onSubmitCopyFromTemplate = async () => {
        if (!copyFromTemplateId) {
            setCopyFromTemplateIdHasError(true);
            setCopyFromTemplateIdErrorText('Please select template');
        } else {
            setCopyFromTemplateInProgress(true);

            let reqBody = {
                copyFromTemplateId: copyFromTemplateId,
                copyToReviewId: store.selectedReviewData._id,
                engagementId: store.selectedReviewData.engagementData._id
            }
            try {
                let response = await store.copyFromTemplate(reqBody);
                if (response && response.status) {
                    store.fetchSimulationListMetadata(true);
                    store.showToaster("info", response.message);
                }
                onCopyFromTemplateModalClose();
            } catch (err) {
                console.log('Some error has occured while copying from template ', err);
            } finally {
                setCopyFromTemplateInProgress(false);
            }
        }
    }

    const getSelectedTemplateReviewDescription = () => {
        if (copyFromTemplateId) {
            let selectedTemplate = store.templates.find((item) => item._id == copyFromTemplateId);
            return selectedTemplate['description'] && <div>
                <b>initialization steps:</b><br />
                {selectedTemplate['description'].split('\n').map((x, idx) => <div key={idx}>{x || <br />}</div>)}
            </div>
        } else {
            return '';
        }
    }

    const onCopyFromTemplateModalClose = () => {
        setCopyFromTemplateIdHasError(false);
        setCopyFromTemplateId('');
        setCopyFromTemplateIdErrorText('');
        setShowCopyFromTemplateModal(false);
    }

    const onCopySimulationModalOpen = () => {
        setCopyFromReviewIdHasError(false);
        setCopyFromReviewId('');
        setCopyFromReviewIdErrorText('');
        setShowCopySimulationModal(true);
    }

    const onCopySimulationModalClose = () => {
        setCopyFromReviewIdHasError(false);
        setCopyFromReviewId('');
        setCopyFromReviewIdErrorText('');
        setShowCopySimulationModal(false);
    }

    const checkIfUserAllowedToCopy = () => {
        let userAllowedToCopy = false;

        let copyFromReviewData = store.myReviews.filter((item) => (item._id == copyFromReviewId));
        let copyToReviewData = store.myReviews.filter((item) => (item._id == store.selectedReviewData._id));

        if (
            copyFromReviewData.length &&
            copyToReviewData.length &&
            props.userInfo &&
            copyFromReviewData[0]['engagement']['allowedEmails'].includes(props.userInfo['email']) &&
            copyToReviewData[0]['engagement']['allowedEmails'].includes(props.userInfo['email'])
        ) {
            userAllowedToCopy = true;
        }

        return userAllowedToCopy;

    }

    const validateCopySimulationForm = () => {
        let isValid = true;

        if (!copyFromReviewId) {
            isValid = false;
            setCopyFromReviewIdHasError(true);
            setCopyFromReviewIdErrorText("Please enter a valid review id");
        } else if (copyFromReviewId && store.selectedReviewData._id == copyFromReviewId) {
            isValid = false;
            setCopyFromReviewIdHasError(true);
            setCopyFromReviewIdErrorText("Please enter a valid review id");
        } else if (copyFromReviewId && !store.myReviews.filter((item) => (item._id == copyFromReviewId)).length) {
            isValid = false;
            setCopyFromReviewIdHasError(true);
            setCopyFromReviewIdErrorText("Review does not exists");
        } else if (!checkIfUserAllowedToCopy()) {
            isValid = false;
            setCopyFromReviewIdHasError(true);
            setCopyFromReviewIdErrorText("You are not allowed to copy");
        } else {
            setCopyFromReviewIdHasError(false);
            setCopyFromReviewIdErrorText('');
        }

        return isValid;
    }

    const onSubmitCopySimulation = async () => {
        if (validateCopySimulationForm()) {
            setCopySimulationInProgress(true);
            let reqBody = {
                copyFromReviewId: copyFromReviewId,
                copyToReviewId: store.selectedReviewData._id,
                engagementId: store.selectedReviewData.engagementData._id
            }
            try {
                let response = await store.copyReviewRelatedSimulations(reqBody);
                if (response && response.status) {
                    store.fetchSimulationListMetadata(true);
                    store.showToaster("info", response.message);
                }
                onCopySimulationModalClose();
            } catch (err) {
                console.log('Some error has occured while copying review related simulations ', err);
            } finally {
                setCopySimulationInProgress(false);
            }
        }
    }

    return (
        <>
            <ConfirmationModal
                maxWidth="sm"
                title="Delete simulations"
                message={"Are you sure you want to delete selected simulations?"}
                open={showDeleteConfirmation}
                onClose={() => { setShowDeleteConfirmation(false) }}
                confirmationBtnText="Delete simulations"
                onConfirm={() => { deleteSimulation() }}
            />
            <ConfirmationModal
                maxWidth="sm"
                title="Re-run simulations"
                message={"Are you sure you want to re-run all simulations?"}
                open={showRerunConfirmation}
                onClose={() => { setShowRerunConfirmation(false) }}
                confirmationBtnText="Re-run"
                onConfirm={() => { setShowRerunConfirmation(false); setShowRerunInfo(true) }}
            />
            <InfoModal
                title="Info"
                message={"After pressing OK it will start. Please do not close the page until you get a DONE message."}
                open={showRerunInfo}
                onClose={() => { setShowRerunInfo(false) }}
                onConfirm={() => { setShowRerunInfo(false); store.reRunSimulations() }}
            />
            <CustomModal
                size="medium"
                title="Copy simulation"
                showModal={showCopySimulationModal}
                onCloseModal={() => {
                    setShowCopySimulationModal(false);
                }}
                submitBtnText={'Copy'}
                onSubmit={(e) => { e.preventDefault(); onSubmitCopySimulation(); }}
                submitBtnDisabled={copySimulationInProgress}
            >
                <>
                    <DialogContentText color="textPrimary">
                        Enter the review id from which you want to copy simulations.
                    </DialogContentText>
                    <form onSubmit={(e) => { e.preventDefault(); onSubmitCopySimulation(); }}>
                        <div css="margin-top: 15px;">
                            <InputText
                                id={"reviewId"}
                                label={"Copy from review id"}
                                value={copyFromReviewId}
                                disabled={false}
                                onChange={(value) => { setCopyFromReviewId(value) }}
                                hasError={copyFromReviewIdHasError}
                                errorText={copyFromReviewIdErrorText}
                            />
                        </div>
                    </form>
                    {copySimulationInProgress &&
                        <div css="margin-top: 15px; padding-bottom: 0px !important;">
                            <Progress />
                        </div>
                    }

                </>
            </CustomModal>
            <CustomModal
                size="medium"
                title="Copy from template"
                showModal={showCopyFromTemplateModal}
                onCloseModal={() => {
                    setShowCopyFromTemplateModal(false);
                }}
                submitBtnText={'Copy'}
                onSubmit={(e) => { e.preventDefault(); onSubmitCopyFromTemplate(); }}
                submitBtnDisabled={copyFromTemplateInProgress}
            >
                <>
                    <DialogContentText color="textPrimary">
                        <div>Please select a template from which you want to copy.</div>
                    </DialogContentText>
                    <form onSubmit={(e) => { e.preventDefault(); onSubmitCopyFromTemplate(); }}>
                        <div css="margin-top: 15px;">
                            <InputDropdown
                                id={"copyFromTemplateId"}
                                label={"Template"}
                                value={copyFromTemplateId}
                                disabled={false}
                                onChange={(value) => { setCopyFromTemplateId(value) }}
                                list={getTemplateList()}
                                hasError={copyFromTemplateIdHasError}
                                errorText={copyFromTemplateIdErrorText}
                            />
                        </div>
                    </form>
                    <div css="padding-top: 15px;">
                        {getSelectedTemplateReviewDescription()}</div>
                    {copyFromTemplateInProgress &&
                        <div css="margin-top: 15px; padding-bottom: 0px !important;">
                            <Progress />
                        </div>
                    }

                </>
            </CustomModal>
            <div>
                <div css="
                display: flex;     
                align-items: start;
                margin-bottom: 25px;
                justify-content: space-between;
            ">{
                        store.allSimulations.length ?
                            <div css="display: flex; align-items: center;">
                                <SearchInput
                                    placeholder='Find simulations'
                                    value={searchString}
                                    disabled={false}
                                    onChange={(value) => { setSearchString(value); store.updateSimulationFilter('searchText', value); }}
                                    onSearch={() => { store.updateSimulationFilter('searchText', searchString) }}
                                    onClear={() => { clearSearch() }}
                                />&nbsp;&nbsp;
                                <div title="Refresh">
                                    <div
                                        css={`cursor:pointer display:flex; align-items: center; flex-direction: column;`}
                                        title="Refresh"
                                        onClick={() => {
                                            onRefresh()
                                        }}
                                    >
                                        {refreshIcon()}
                                        <div>Refresh</div>
                                    </div>
                                </div>
                            </div>
                            : <div>
                                No simulation found
                            </div>
                    }

                    <div css={`display:flex;align-items:center;`}>
                        <div css={`cursor:pointer;color:blue;text-decoration:underline; padding-right: 12px;`} onClick={() => store.showEditReviewFileModal(qs().review_id)}>
                            Edit review files
                        </div>
                        <div css={`cursor:pointer;color:blue;text-decoration:underline;`} onClick={() => onDefineDefaultStepClick()}>
                            Edit initialization steps
                        </div>
                        <div css={`display:inline-flex;align-items:center;`}>
                            <div>
                                {
                                    qs().review_id &&
                                    <>
                                        <div>
                                            <IconButton
                                                aria-label="more"
                                                aria-controls="long-menu"
                                                aria-haspopup="true"
                                                onClick={handleClick}
                                            >
                                                {moreIcon}
                                            </IconButton>
                                            <Menu
                                                id="long-menu"
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={openMoreOptions}
                                                onClose={handleClose}
                                            >
                                                <MenuItem key={1} onClick={() => { inputFile.current.click(); handleClose(); }}>
                                                    <input type='file' id='file' ref={inputFile} style={{ display: 'none' }} accept="application/JSON" onChange={(e) => onChangeFile(e)} />
                                                    {importIcon()}&nbsp;Upload simulations
                                                </MenuItem>
                                                {
                                                    store.selectedReviewData?.engagement?.engId != "Templates" &&
                                                    <MenuItem key={2} onClick={() => { setShowCopyFromTemplateModal(true); handleClose(); }}>
                                                        {CopyIcon()}&nbsp;Copy from template
                                                    </MenuItem>
                                                }
                                                <MenuItem key={3} onClick={() => { store.history.push(consts.SCR_APP_URLS.ciReview + '/' + store.selectedReviewData._id); handleClose(); }}>
                                                    {DirectionIcon()}&nbsp;Go to ci reviews
                                                </MenuItem>
                                                <MenuItem key={4} onClick={() => { onCopySimulationModalOpen(); handleClose(); }}>
                                                    {CopyIcon()}&nbsp;Copy all simulations
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                </div>

                {
                    store.allSimulations.length ?
                        <>
                            <div css="display: flex; justify-content: space-between; margin-bottom: 25px;">
                                <div css="
                                    display: flex; 
                                    align-items: center;
                                    width: 100%;
                                    justify-content: start;
                                ">
                                    {!!getAllSimulationFunctionList().length &&
                                        <div css="width: 20%;min-width:160px; padding-right: 25px;">
                                            <InputDropdown
                                                id={"filterByFunction"}
                                                label={"Filter by function"}
                                                value={store.simulationFilter.function}
                                                disabled={false}
                                                showClearOption={store.simulationFilter.function != 'All'}
                                                onClear={() => { store.updateSimulationFilter('function', 'All') }}
                                                onChange={(value) => { store.updateSimulationFilter('function', value) }}
                                                list={getAllSimulationFunctionList()}
                                            />
                                        </div>}
                                    {!!getAllSimulationCreatorList().length &&
                                        <div css="width: 20%;min-width:160px; padding-right: 25px;">
                                            <InputDropdown
                                                id={"filterByCreator"}
                                                label={"Filter by creator"}
                                                value={store.simulationFilter.creator}
                                                disabled={false}
                                                showClearOption={store.simulationFilter.creator != 'All'}
                                                onClear={() => { store.updateSimulationFilter('creator', 'All') }}
                                                onChange={(value) => { store.updateSimulationFilter('creator', value) }}
                                                list={getAllSimulationCreatorList()}
                                            />
                                        </div>
                                    }
                                    <div css="width: 20%;min-width:160px; padding-right: 25px;">
                                        <InputDropdown
                                            id={"filterByPassOrFail"}
                                            label={"Filter by pass/fail"}
                                            value={store.simulationFilter.passExpections}
                                            disabled={false}
                                            showClearOption={store.simulationFilter.passExpections != 'All'}
                                            onClear={() => { store.updateSimulationFilter('passExpections', 'All') }}
                                            onChange={(value) => { store.updateSimulationFilter('passExpections', value) }}
                                            list={getAllSimulationPassFailList()}
                                        />
                                    </div>
                                    {!store.isTemplateReview && <div css="width: 20%;min-width:160px; padding-right: 25px;">
                                        <InputDropdown
                                            id={"filterByTemplate"}
                                            label={"Filter by template"}
                                            value={store.simulationFilter.template}
                                            disabled={false}
                                            showClearOption={store.simulationFilter.template != 'All'}
                                            onClear={() => { store.updateSimulationFilter('template', 'All') }}
                                            onChange={(value) => { store.updateSimulationFilter('template', value) }}
                                            list={getAllSimulationTemplateList()}
                                        />
                                    </div>}
                                    <div css="width: 20%;min-width:160px; padding-right: 25px;">
                                        <InputDropdown
                                            id={"sortBy"}
                                            label={"Sort by"}
                                            value={store.simulationFilter.sortBy}
                                            disabled={false}
                                            showClearOption={store.simulationFilter.sortBy != 'Created'}
                                            onClear={() => { store.updateSimulationFilter('sortBy', 'Created') }}
                                            onChange={(value) => { store.updateSimulationFilter('sortBy', value) }}
                                            list={getSortByTypes()}
                                        />
                                    </div>
                                    <div css="width: 20%;min-width:160px;">
                                        <InputDropdown
                                            id={"simulationType"}
                                            label={"Simulation type"}
                                            value={store.simulationFilter.simulationType}
                                            disabled={false}
                                            showClearOption={store.simulationFilter.simulationType != 'All'}
                                            onClear={() => { store.updateSimulationFilter('simulationType', 'All') }}
                                            onChange={(value) => { store.updateSimulationFilter('simulationType', value) }}
                                            list={getSimulationTypeList()}
                                        />
                                    </div>
                                </div>
                            </div>
                            {
                                (qs().review_id && store.simulations.length > 0) ?
                                    <>

                                        <div css="display: flex; align-items: center; justify-content: flex-start;">
                                            <div>
                                                <InputCheckBox
                                                    checked={store.getAllSimulationSelectionStatus()}
                                                    onChange={(value) => { changeAllSimulationSelection(value) }}
                                                    label={store.getAllSimulationSelectionStatus() ? 'Deselect all' : 'Select all'}
                                                />
                                            </div>
                                            {
                                                Object.keys(store.selectedSimulationList).length ?
                                                    <>
                                                        <div css="display: flex; align-items: center; justify-content: flex-start; margin: 0 16px 0 0">
                                                            <Tooltip
                                                                tip={'Delete selected simulations'}
                                                            >
                                                                <div
                                                                    css={`cursor:pointer; display: flex; align-items: center; justify-content: flex-start;`}
                                                                    onClick={() => setShowDeleteConfirmation(true)}
                                                                >
                                                                    {TrashIcon2()}&nbsp;Delete
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                        |
                                                        <div css="margin: 0 16px 0 16px">
                                                            <Tooltip
                                                                tip={'Download simulations'}
                                                            >
                                                                <div
                                                                    css={`cursor:pointer; display: flex; align-items: center; justify-content: flex-start;`}
                                                                    onClick={() => store.exportSimulationsAsJSON()}
                                                                >
                                                                    {exportIcon()}&nbsp;Download
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                        |
                                                        <div css="margin: 0 16px 0 16px">
                                                            <Tooltip
                                                                tip={'Print'}
                                                            >
                                                                <div
                                                                    css={`cursor:pointer;  display: flex; align-items: center; justify-content: flex-start;`}
                                                                    onClick={() => store.doPrint()}
                                                                >
                                                                    {printIcon()}&nbsp;Print
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                        |
                                                        <div css="margin: 0 16px 0 16px">
                                                            <Tooltip
                                                                tip={'Re-run simulations'}
                                                            >
                                                                <div
                                                                    css={`cursor:pointer;  display: flex; align-items: center; justify-content: flex-start;`}
                                                                    onClick={() => setShowRerunConfirmation(true)}
                                                                >
                                                                    {refreshIcon()}&nbsp;Re-run
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    </> : null
                                            }

                                        </div>
                                        {
                                            <div>{Object.keys(store.selectedSimulationList).length}/{store.allSimulations.length} selected</div>
                                        }

                                    </> : null
                            }
                        </> : null
                }
            </div >
        </>
    )

}
